import React from 'react';
import { OrganizationRoleDto } from 'src/api/FiretrolApiClient';
import { useOrganization } from 'src/hooks/useOrganization';
import { PersistentSelect } from 'src/design/atoms/PersistentSelect';

export interface IRoleSelector2Props {
  onChange: (role: OrganizationRoleDto[]) => void;
  initialValue?: OrganizationRoleDto[];
  placeholder?: string;
  value: OrganizationRoleDto[];
}

export const RoleSelector2: React.FC<IRoleSelector2Props> = ({
  onChange,
  initialValue = [],
  placeholder = 'Select user roles...',
}) => {
  const { roles } = useOrganization();
  const [selected, setSelected] =
    React.useState<OrganizationRoleDto[]>(initialValue);
  React.useEffect(() => {
    onChange(selected);
  }, [selected]);

  return (
    <>
      <PersistentSelect
        options={roles}
        value={selected}
        onChange={setSelected}
        placeholder={placeholder}
        inputProps={{
          label: undefined,
        }}
        emptyMessage="No roles found..."
        getOptionId={(option) => option.id.toString()}
        getOptionLabel={(option) => option.name}
      />
    </>
  );
};
